import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { FetchApiDataOptions } from './eventSlice'
import { AxiosError, AxiosResponse } from 'axios'
import { fetchDataFromApi } from '../services/fetchDataFromApi'
import { NwLecturerApplicationDto } from '../types/NwLecturerApplicationDto.tsx'
import { NwDbFile } from '../types/settingTypes/NwDbFile.tsx'

interface ApiState {
  selectedRegistration: NwLecturerApplicationDto | undefined
  selectedIdx: number | undefined
  registrations: NwLecturerApplicationDto[]
  files: NwDbFile[]
  loading: 'idle' | 'pending' | 'succeeded' | 'failed'
  error: string | null
  statusCode: number | null
}

const initialState: ApiState = {
  selectedRegistration: undefined,
  selectedIdx: undefined,
  registrations: [],
  files: [],
  loading: 'idle',
  error: '',
  statusCode: 0,
}

// Sperrzeiten add/update
export const deleteFile = createAsyncThunk('api/deleteFile', async ({ url, token, bodyData }: FetchApiDataOptions) => {
  try {
    const data: AxiosResponse | AxiosError = await fetchDataFromApi(url, token, 'DELETE', 'json', bodyData)
    return data
  } catch (error: any) {
    // Fehlerbehandlung
  }
})

const register = createSlice({
  name: 'registerStore',
  initialState,
  reducers: {
    setSelectedRegistration: (state, action) => {
      state.selectedRegistration = action.payload as NwLecturerApplicationDto
    },
    clearSelectedRegistration: (state) => {
      state.selectedRegistration = undefined
    },
    setRegistrations: (state, action) => {
      state.registrations = action.payload as NwLecturerApplicationDto[]
      state.selectedIdx = state.registrations.length - 1
    },
    clearRegistrations: (state) => {
      state.registrations = []
      state.selectedRegistration = undefined
      state.selectedIdx = undefined
    },
    addRegistrationToList: (state, action) => {
      state.registrations = [...state.registrations, action.payload]
      state.selectedIdx = state.registrations.length - 1
    },
    setSelectedRegIdxFromDd: (state, action) => {
      state.selectedIdx = action.payload
      console.log(state.selectedIdx)
    },
    setFiles: (state, action) => {
      state.files = action.payload
    },
    removeFile: (state, action) => {
      state.files = state.files.filter((file) => file.id !== action.payload.id)
      console.log('removed')
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(deleteFile.pending, (state) => {
        state.loading = 'pending'
      })
      .addCase(deleteFile.rejected, (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message || 'An error occurred'
      })
      .addCase(deleteFile.fulfilled, (state, action) => {
        const result = action.payload
        if (result instanceof AxiosError) {
          if (result?.status < 200 || result.status >= 300) {
            state.statusCode = result.status
          } else if (result.code === 'ERR_NETWORK') {
            state.statusCode = 503
          } else if (result.code === 'ERR_BAD_REQUEST') {
            state.statusCode = 403
          } else {
            state.statusCode = result.status
          }
          state.loading = 'failed'
          state.error = result.statusText
        } else if (result) {
          state.loading = 'succeeded'
        }
      })
  },
})

export const { clearSelectedRegistration, addRegistrationToList, setSelectedRegistration, setRegistrations, setSelectedRegIdxFromDd, setFiles, removeFile, clearRegistrations } = register.actions
export default register.reducer
